// When a handler does both `setListMode(...)` and a fly/fit call in the same
// tick, the fly runs synchronously while the previous panel is still mounted.
// That panel's height is what `atom_mobileListHeight` holds, so the fly's
// bottom-obstruction read is stale — the fit/center math uses the panel that's
// about to UNMOUNT, not the one the user will see after the render commits.
//
// flyAfterLayout defers the fly until:
//   1) React has committed the pending state change (first rAF),
//   2) the new panel has mounted, measured itself, and updated the atom
//      (second rAF — covers useResizablePanel's mount-effect chain).
//
// After both frames, the snapshot read inside getBottomObstruction returns
// the freshly-mounted panel's height. Live, but post-commit.
//
// Use ONLY when the same handler that triggers the fly is also changing the
// list mode. For flies that don't change the panel (user clicks a stop in the
// list), call the fly directly — no defer needed.
export function flyAfterLayout(fn: () => void): void {
  requestAnimationFrame(() => {
    requestAnimationFrame(fn);
  });
}
